/** Keep number controls narrow without clipping ordinary four-decimal values. */
export function accountingNumberWidth(value: number | null | undefined, minimum = 8, maximum = 18, minimumFractionDigits = 4): string {
    const digits = Number(value ?? 0).toLocaleString('en-US', { minimumFractionDigits, maximumFractionDigits: 4 }).length + 4;
    return `${Math.min(maximum, Math.max(minimum, digits))}ch`;
}
